module.exports = __webpack_public_path__ + "img/fintechzoom.e266a07c.png";